import React, { useEffect, useState, useMemo } from "react";
import axios from "axios";
import { Link, useParams } from "react-router-dom";
import { FiEdit3, FiEye, FiTrash2 } from "react-icons/fi";
import Table from "../shared/table/Table";
import { toast } from "react-toastify";
import { confirmAlert } from "react-confirm-alert";

export default function DualResultTable() {
  const { testId: testId } = useParams(); // /test/dual-results/:id route’undan geliyor
  const [rows, setRows] = useState([]);
  const [testName, setTestName] = useState(""); //  test adı için state
  const [linkedCounts, setLinkedCounts] = useState({});

    const fetchTestName = async () => {
    try {
      const token = localStorage.getItem("admin_token");
      const { data } = await axios.get(
        `${process.env.REACT_APP_API_BASE_URL}/api/tests/${testId}`,
        { headers: { Authorization: `Bearer ${token}` } }
      );
      setTestName(data?.name || "");
    } catch (err) {
      console.error("❌ test adı alınamadı:", err);
      toast.error("Test adı alınamadı");
    }
  };

  const fetchRows = async () => {
    try {
      const token = localStorage.getItem("admin_token");
      const { data } = await axios.get(
        `${process.env.REACT_APP_API_BASE_URL}/api/dual-results/tests/${testId}/dual-results`,
        { headers: { Authorization: `Bearer ${token}` } }
      );
      setRows(data || []);
    } catch (err) {
      console.error("❌ dual results fetch error:", err);
      toast.error("Sonuçlar alınamadı");
    }
  };

  // 🔗 Bu testteki soruları çek ve dual_result_id'ye göre say
  const fetchLinkedCounts = async () => {
    try {
      const token = localStorage.getItem("admin_token");
      const { data } = await axios.get(
        `${process.env.REACT_APP_API_BASE_URL}/api/tests/${testId}/questions`,
        { headers: { Authorization: `Bearer ${token}` } }
      );
      const counts = {};
      (Array.isArray(data) ? data : []).forEach((q) => {
        const drId = q?.dual_result_id;
        if (drId) counts[drId] = (counts[drId] || 0) + 1;
      });
      setLinkedCounts(counts);
    } catch (err) {
      console.error("❌ linked counts alınamadı:", err);
    }
  };


  useEffect(() => { fetchRows(); fetchTestName(); fetchLinkedCounts();}, [testId]);

  const handleDelete = (rowId) => {
    const cnt = linkedCounts[rowId] || 0;
    if (cnt > 0) return; // güvenlik: zaten disable, yine de koru

    confirmAlert({
      title: "Silmek istediğinize emin misiniz?",
      message: "Bu işlem geri alınamaz.",
      buttons: [
        {
          label: "Evet, sil",
          onClick: async () => {
            try {
              const token = localStorage.getItem("admin_token");
              await axios.delete(
                `${process.env.REACT_APP_API_BASE_URL}/api/dual-results/tests/${testId}/dual-results/${rowId}`,
                { headers: { Authorization: `Bearer ${token}` } }
              );
              toast.success("Silindi");
              // listeyi ve bağlı sayıları yenile
              fetchRows();
              fetchLinkedCounts();
            } catch (err) {
              console.error("❌ delete error:", err);
              toast.error("Silme başarısız oldu");
            }
          },
        },
        { label: "İptal", onClick: () => {} },
      ],
    });
  };

  const columns = useMemo(() => [
    { accessorKey: "id", header: "ID", size: 60 },
    { accessorKey: "title", header: "Başlık" },
    {
      id: "actions",
      header: "İşlemler",
      enableSorting: false,
      cell: (info) => {
        const row = info.row.original;
                  const count = linkedCounts[row.id] || 0;
          const disabled = count > 0;
        return (
          <div className="hstack gap-2 justify-content-end">
<Link
  to={`/test/dual-results/view/${testId}/${row.id}`}
  className="avatar-text avatar-md text-primary bg-soft-primary border-soft-primary"
  title="Görüntüle"
>
  <FiEye />
</Link>

<Link
  to={`/test/dual-results/edit/${testId}/${row.id}`}
  className="avatar-text avatar-md text-success bg-soft-success border-soft-success"
  title="Düzenle"
>
  <FiEdit3 />
</Link>
<span
  role="button"
  aria-disabled={disabled}
  title={disabled ? "Bu başlığa bağlı sorular var, silemezsiniz" : "Sil"}
  onClick={() => { if (!disabled) handleDelete(row.id); }}
  onMouseDown={(e) => { if (disabled) e.preventDefault(); }}
  className="avatar-text avatar-md"
  style={{
    color: disabled ? "#9aa0a6" : "#dc3545",
    backgroundColor: disabled ? "#f1f3f4" : "rgba(220,53,69,0.12)",
    borderColor: disabled ? "#f1f3f4" : "rgba(220,53,69,0.12)",
    cursor: disabled ? "default" : "pointer",
    opacity: disabled ? 0.7 : 1,
  }}
>
  <FiTrash2 />
</span>



            </div>
          );
        },
      },
    ],
    [testId, linkedCounts] );

return (
  <div className="container my-4">
    {/* Üst şerit: bağlam satırı */}
    <div className="d-flex align-items-center justify-content-between mb-3">
      <div className="small text-muted">
        Test: <strong>{testName || "İkili Sonuç Tablosu"}</strong>
      </div>
    </div>

    <Table data={rows} columns={columns} />
  </div>
);

}
